<template>
  <div class="position_list">
    <div class="container">
      <el-card :body-style="{ padding: '12px 16px' }">
        <el-form>
          <el-form-item label="工作地点：">
            <!-- <CascaderArea
              :country="queryInfo.workIntro"
              :province="queryInfo.companyProvince"
              :city="queryInfo.companyCity"
              @searchArae="searchArae"
              class="CascaderArea"
            /> -->
            <div class="distpicker">
              <!-- @selected="onSelected" -->
              <v-distpicker
                @province="provinceChanged"
                @city="cityChanged"
                @area="areaChanged"
                :province="queryInfo.companyProvince"
                :city="queryInfo.companyCity"
                :area="queryInfo.companyArea"
              ></v-distpicker>
            </div>
          </el-form-item>
          <el-form-item label="学历要求：">
            <!-- <multiSelect
            typeCode="005"
            @searchLabel="searchLabel"
            :code.sync="queryInfo.cilentIndustry"
        /> -->
            <radio-select
              :code.sync="queryInfo.educationalRequirements"
              type-code="007"
              query-name="educationalRequirements"
              name="学历要求"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="职位类型：">
            <multiSelect
              typeCode="008"
              @change="changePositionType"
              :code.sync="queryInfo.positionType"
            />
          </el-form-item>
        </el-form>
      </el-card>
      <el-card style="margin-top: 12px">
        <div class="enterporise_list_input_add">
          <div class="input_new">
            <el-input
              placeholder="请输入相关职位名称"
              v-model="queryInfo.jobTitle"
              class="input-with-select"
              clearable
            >
              <el-button slot="append" icon="el-icon-search" @click="searchTalent"></el-button>
            </el-input>
          </div>
          <el-button type="primary" class="add_enterprise" @click="addClient()"
            >+新增职位</el-button
          >
        </div>
        <div class="listStyle flexOne" v-for="(item, index) in clientTableData" :key="index">
          <div class="flexAround">
            <div>
              <img
                :src="item.companyLogoKey"
                alt=""
                v-if="item.companyLogoKey"
                @click="viewItem(item)"
              />
              <img :src="pro" alt="" v-else @click="viewItem(item)" />
            </div>
            <div style="margin-left: 10px" class="cloumFlex">
              <div class="jobTitle">
                {{ item.jobTitle
                }}<span v-if="item.companyProvince || item.companyArea || item.companyCity"
                  >[<span v-if="item.companyProvince">{{ item.companyProvince }}</span
                  ><span v-if="item.companyCity">-{{ item.companyCity }}</span
                  ><span v-if="item.companyArea">-{{ item.companyArea }}</span
                  >]</span
                >
              </div>
              <div class="corporateName">{{ item.corporateName }}</div>
              <div class="positionType">
                职位类型：<span>{{ item.positionType }}</span>
              </div>
              <div class="positionType">
                学历要求：<span>{{ item.educationalRequirements }}</span>
              </div>
              <div class="positionType">
                薪资范围：<span v-if="item.isAnnual">年薪</span><span v-else>月薪</span
                ><span style="margin-left: 10px">{{ item.salaryRange }}</span>
              </div>
            </div>
          </div>
          <div class="cloumFlexBetween">
            <div
              style="width: 400px; font-size: 12px; color: #b2b2b2"
              v-if="item.jobDescription && item.jobDescription.length > 40"
            >
              职位描述：{{ item.jobDescription.substring(0, 40) }}...
            </div>
            <div
              style="width: 400px"
              v-else-if="item.jobDescription && item.jobDescription.length < 40"
            >
              职位描述：{{ item.jobDescription }}
            </div>
            <div style="width: 400px" v-else>职位描述：</div>
            <div class="flexOne">
              <div class="flexNormal">
                <div class="flexNormal" style="margin-right: 20px" @click="editItem(item)">
                  <dic-button icon="icon-jr-icon-modify" text="编辑" />
                  <span style="color: #17757a">编辑</span>
                </div>
                <div class="flexNormal" @click="deleteItem(item)">
                  <dic-button icon="icon-jr-icon-delete" text="删除" />
                  <span style="color: #ff6c66">删除</span>
                </div>
              </div>
              <div class="information_source">
                <p style="font-size: 13px">信息来源：{{ item.skills }}</p>
                <p style="font-size: 13px">最近更新时间：{{ item.updateTime }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="page_nation pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[30, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// import CascaderArea from '@/components/CascaderArea.vue'
import radioSelect from '@/components/RadioSelect.vue'
import DicButton from '@/components/DicButton.vue'
import { getpositionList, deleteposition } from '@/api/position.js'
import multiSelect from '@/components/MultiSelect.vue'
import { pagination } from '@/mixins/pagination'
// import DicButton from '@/components/DicButton.vue'
import pro from '../../../../static/images/pro.png'
const defaultQueryObj = Object.freeze({
  companyArea: '', // 所属地区 区、县
  corporateName: '', //公司名称
  educationalRequirements: '', //职位类型
  positionType: [], //学历要求
  companyCity: '', //客户所属城市
  companyProvince: '', //客户所属省份
  workIntro: '中国', //客户所在地区
  order: '0', //排序
  pageNum: 0, //页数
  pageSize: 10, //大小
  size: '', //所选条数
  jobTitle: ''
})
export default {
  mixins: [pagination],
  // CascaderArea,
  components: {
    multiSelect,
    radioSelect,
    DicButton
    // DicButton
  },
  created() {
    // if (Object.keys(this.$store.state.queryInfo).length) {
    //   Object.keys(this.$store.state.queryInfo).forEach((item) => {
    //     this.queryInfo[item] = this.$store.state.queryInfo[item]
    //   })
    // }
    // console.log(this.queryInfo)
    this.search()
  },
  data() {
    return {
      queryInfo: { ...defaultQueryObj },
      clientTableData: [],
      pro,
      total: null,
      dynamicTags: [
        {
          name: '学历要求',
          tagName: 'educationalRequirements'
        },
        {
          name: '职位类型',
          tagName: 'positionType'
        }
      ]
    }
  },
  methods: {
    onChange(val, queryName, name) {
      if (!this.dynamicTags.some((item) => item.tagName === queryName)) {
        this.dynamicTags.push({
          name,
          tagName: queryName
        })
      }
      this.search()
    },
    searchTalent() {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 30
      this.search()
    },
    async search() {
      const res = await getpositionList(this.queryInfo)
      if (res.data.resultCode == 200) {
        this.clientTableData = res.data.data.list
        this.total = res.data.data.total
      }
    },
    closeTag(index, name) {
      this.dynamicTags.splice(index, 1)
      this.queryInfo[name] = ''
      this.search()
    },
    // 添加
    addClient() {
      this.$router.push({
        name: 'PositionMessage',
        query: {
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    viewItem(row) {
      this.$router.push({
        name: 'PositionMessageView',
        query: {
          id: row.id,
          clientType: 1,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    // 修改
    editItem(row) {
      this.$router.push({
        name: 'PositionMessage',
        query: {
          id: row.id,
          clientType: 1,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    // 删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteposition([row.id])
          if (res.resultCode == 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    // 国家城市
    // searchArae(val) {
    //   this.queryInfo.workIntro = val.country

    //   this.queryInfo.companyProvince = val.province

    //   if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
    //     this.queryInfo.companyCity = val.city
    //   }

    //   this.search()
    // },
    //工作地址
    // onSelected(data) {
    //   //选中最后一项时触发
    //   this.queryInfo.companyProvince = data.province.value
    //   this.queryInfo.companyCity = data.city.value
    //   this.queryInfo.companyArea = data.area.value
    //   console.log(data)
    //   this.search()
    // },
    // 选中省份
    provinceChanged(val) {
      if (val.value === '省') {
        this.queryInfo.companyProvince = ''
        this.search()
      } else {
        this.queryInfo.companyProvince = val.value
        this.search()
      }
    },
    // 选中城市
    cityChanged(val) {
      if (val.value === '市') {
        this.queryInfo.companyCity = ''
        this.search()
      } else {
        this.queryInfo.companyCity = val.value
        this.search()
      }
    },
    // 选中地区
    areaChanged(val) {
      if (val.value === '区') {
        this.queryInfo.companyArea = ''
        this.search()
      } else {
        this.queryInfo.companyArea = val.value
        this.search()
      }
    },
    changePositionType(data) {
      this.queryInfo.positionType = data
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .distpicker-address-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .distpicker-address-wrapper label {
  width: 32%;
}
::v-deep .distpicker-address-wrapper label select {
  width: 100%;
  height: 40px;
  font-size: 14px;
  padding: 0 5px;
  border: 1px solid #17757a;
}
.container {
  height: 82vh;
  overflow: auto;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}
.position_list {
  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }
  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  .enterporise_list_input_add {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 20px;
    /deep/ .input-with-select {
      width: 320px;
      margin-right: 50px;
    }
    .input_new {
      /deep/ .el-button {
        border-radius: 0 4px 4px 0;
        height: 40px;
      }

      /deep/ .el-button--default {
        background-color: #17757a;

        i {
          color: #fff;
        }
      }
    }

    .add_enterprise {
      background-color: #17757a;
      border-color: #17757a;
    }
  }
  .enterprise_table {
    margin-top: 20px;
    width: 100%;
    .el_image {
      width: 48px;
      height: 48px;
      border-radius: 4px;
    }
  }
  .operation_bottom {
    .operation_border {
      font-size: 18px;
      color: #e8e8e8;
    }
  }
  .CascaderArea {
    /deep/ .el-input__inner {
      border: 1px solid #17757a;
      color: #17757a;
      height: 34px;
      line-height: 34px;
    }
  }
  /deep/ .el-image__inner {
    border-radius: 5px;
  }
  .distpicker {
    margin-right: 10px;
    width: 600px;
  }
}
.listStyle {
  padding: 10px;
  border-bottom: 1px solid #e5e5e5;
  img {
    width: 100px;
    height: 100px;
    padding: 5px;
    cursor: pointer;
  }
}
.flexOne {
  display: flex;
  justify-content: space-between;
  .information_source {
    p {
      font-size: 10px !important;
      color: #b2b2b2;
    }
  }
}
.flexAround {
  display: flex;
  .jobTitle {
    color: #17757a;
    font-size: 18px;
    font-weight: 600;
  }
  .corporateName {
    font-size: 14px;
    color: #000;
  }
  .positionType {
    color: #333333;
    font-size: 14px;
  }
}
.cloumFlex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.cloumFlexBetween {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flexNormal {
  display: flex;
  align-items: center;
  cursor: pointer;
  /deep/ .el-button i {
    font-size: 19px !important;
  }
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}
</style>
